query MobileDashboardData(
	$days: Int!
	$days2n: Int!
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$mfaOsFilter: ConditionStringArray
	$mfaAppIdFilter: ConditionStringArray
	$msdkOsFilter: ConditionString
	$msdkAppFilter: ConditionString
) {
	mfaIssuesCount: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
		group: run_updated_at_truncDay
	) {
		run_updated_at_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	mfaIssuesCount2n: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days2n] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
		group: run_updated_at_truncDay
	) {
		run_updated_at_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	msdkIssuesCount: msdk_report_runs(
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	msdkIssuesCount2n: msdk_report_runs(
		run_time_last_n_days: { value: [$days2n] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
		group: run_time_truncDay
	) {
		run_time_truncDay
		critical_issues_sum
		serious_issues_sum
		total_issues_sum
	}
	mfaSummary: mfa_session_runs(
		run_updated_at_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $mfaOsFilter
		app_id_eq_any_item_for_any_value: $mfaAppIdFilter
	) {
		critical_issues_sum
		total_issues_sum
		run_updated_at_max
	}
	msdkSummary: msdk_report_runs(
		run_time_last_n_days: { value: [$days] }
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
	) {
		critical_issues_sum
		total_issues_sum
		run_time_max
	}
}
